import { FC, useEffect } from "react";
import Dialog, { DialogTitle, DialogContent } from "@/components/Dialog";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import { useTrackers } from "@/hooks";
import styles from "./CoordinatorLockDialog.module.scss";

type Props = {
  onClose: () => void;
};

const CoordinatorLockDialog: FC<Props> = ({ onClose }) => {
  const { track } = useTrackers();

  useEffect(() => {
    track("Job Locked Coordinator Dialog Opened", {
      eventId: "job-locked-coordinator-dialog-opened",
    });
  }, []);

  const handleClose = () => {
    track("Job Locked Coordinator Clicked", {
      eventId: "job-locked-coordinator-clicked",
    });
    onClose();
  };

  return (
    <Dialog
      open
      classes={{ paper: styles.paper }}
      BackdropProps={{
        classes: { root: styles.backdrop },
      }}
    >
      <DialogTitle hasCloseButton={false}>Unlocking soon</DialogTitle>
      <DialogContent className={styles.content}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={"/images/jobs-coordinator-lock.svg"}
          alt="icon"
          className={styles.image}
        />
        <Typography variant="h6" className={styles.title}>
          Coming soon!
        </Typography>
        {/* <Typography variant="h6">Get ready for exclusive access</Typography> */}
        <Typography
          color="text.secondary"
          variant="body1"
          className={styles.description}
        >
          We&apos;re in the process of finding the perfect Arrival Coordinator
          for you. Once assigned and you&apos;re close to your arrival date
          you&apos;ll gain exclusive access to the Global Job Board to start
          browsing the available jobs!
        </Typography>
        <Button onClick={onClose} className={styles.button}>
          Great
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CoordinatorLockDialog;
